export const translations = {
  en: {
    nav: {
      license: "Licensed Agent · #21295806",
      links: { services: "Services", recovery: "Recovery", about: "About", consult: "Consult", faq: "FAQ" },
      book: "Book a 1-on-1",
      call: "Call 808-500-4711",
      menuOpen: "Open menu",
      menuClose: "Close menu",
    },
    hero: {
      badge: "Licensed Life, Estate & Trust Agent · #21295806",
      location: "Wailuku · Maui, Hawai\u02BBi",
      lines: ["PLAN.", "PROTECT.", "PROVIDE."],
      paragraph:
        "A warm aloha from Dustin Campos — independent agent and small business owner. My office offers platinum-tier life insurance & annuity companies you won\u2019t find online, careful estate & trust planning, and respectful recovery of money that already belongs to you.",
      cta: "Book a 1-on-1 Consultation",
      textCta: "Text 808-298-4096",
      chips: ["No upfront fees", "20% only if we succeed", "Serving all of Maui, HI"],
      floatA: "Your Legacy,",
      floatB: "My Focus.",
      floatBadge: "Independent Agent",
      imgAlt: "Dustin Campos, licensed life, estate and trust agent in Wailuku, Maui",
    },
    marquee: [
      "Platinum Life Insurance",
      "Estate & Trust Planning",
      "Final Expense Coverage",
      "Asset & Check Recovery",
      "No Upfront Fees",
      "Serving Maui, Hawai\u02BBi",
    ],
    services: {
      eyebrow: "What my office specializes in",
      titleA: "Platinum coverage.",
      titleB: "Careful planning.",
      titleC: " Money recovered.",
      intro:
        "Three disciplines, one standard: honest advice, patient explanations, and options most people are never shown. Everything begins with a conversation, never a sales pitch.",
      cards: [
        {
          title: "Platinum Life Insurance & Annuities",
          body: "My office specializes in platinum-grade life insurance and annuity companies that are not accessible to the public. Coverage and quotes are available exclusively through a private 1-on-1 planning session.",
        },
        {
          title: "Estate & Trust Planning",
          body: "Thoughtful structuring of what you\u2019ve built \u2014 so your wishes are honored and the people you love are protected with confidence.",
        },
        {
          title: "Final Expense Coverage",
          body: "Dignified, practical coverage so the costs of saying goodbye never land on your family\u2019s shoulders.",
        },
        {
          title: "Private quotes, by appointment only",
          body: "These carriers don\u2019t advertise to the public \u2014 that\u2019s the point. Sit down with Dustin, compare real numbers, and leave with a plan built around your \u2018ohana.",
        },
      ],
      cta: "Reserve your session",
    },
    recovery: {
      eyebrow: "Asset recovery",
      titleA: "Found money has a",
      titleB: "deadline.",
      intro:
        "Undeposited checks and unclaimed cash cross my company\u2019s desk. I help individuals, businesses and families collect what is theirs \u2014 respectfully, patiently, and with everything explained before you sign anything.",
      warningLead: "Here is the honest urgency:",
      warning:
        "if these funds are ignored, they are eventually sent to the state as generalized funds. I don\u2019t believe money that belongs to your family should end up in a government account. That belief is why I do this work.",
      steps: [
        {
          title: "We locate it",
          body: "Undeposited and open checks, unclaimed cash and dormant accounts surface through my company\u2019s work. If a match points to you, I reach out.",
        },
        {
          title: "You sign a limited authorization",
          body: "An acknowledgment letter authorizes me with limited power \u2014 only to contact the holding entity and confirm your funds. Nothing more.",
        },
        {
          title: "You collect, then I get paid",
          body: "Funds go directly to you. My 20% fee is due only after a successful recovery \u2014 never before, never upfront.",
        },
      ],
      calc: {
        label: "Recovery estimator",
        title: "What could come back to you",
        description:
          "Slide to an estimated fund amount. The math is always the same: no upfront cost, and a 20% share only when the recovery succeeds.",
        estLabel: "Estimated fund",
        grossLabel: "Recovered funds",
        feeLabel: "Dustin\u2019s fee (20%, only on success)",
        netLabel: "You receive",
        cta: "Check your case",
      },
    },
    about: {
      eyebrow: "Meet Dustin",
      titleA: "Your legacy,",
      titleB: "my focus.",
      p1: "I\u2019m Dustin Campos, a licensed life, estate & trust agent (License #21295806) and a small business owner here in Wailuku. My practice was built the old way \u2014 one conversation, one family, one plan at a time.",
      p2: "My office specializes in platinum life insurance and annuity companies that simply aren\u2019t accessible to the public. Those options open up when we sit down together for a 1-on-1 quote and planning session. Alongside that, I run an asset recovery practice: open checks and unclaimed cash that cross my company\u2019s desk, matched back to the individuals, businesses and families they belong to.",
      p3: "Whether you\u2019re protecting what you\u2019ve built or reclaiming what\u2019s already yours, you deserve straight answers in plain language \u2014 with the patience and respect you\u2019d expect from a neighbor.",
      quote: "I don\u2019t believe your money should become the state\u2019s generalized funds.",
      quoteBy: "— Dustin Campos",
      islandAlt: "Lush coastline of Maui, Hawai\u02BBi",
      facts: [
        { label: "Licensed Life, Estate & Trust Agent", value: "License #21295806" },
        { label: "Office rooted in", value: "Wailuku, Maui" },
        { label: "Independent agent", value: "Small business owner" },
      ],
    },
    consult: {
      eyebrow: "1-on-1 consultation",
      titleA: "Sit down with Dustin.",
      titleB: "Policy review or estate & trust.",
      intro:
        "Choose a time below to go over your policy options or your estate & trust plan \u2014 in person or by phone. Prefer texting? Scan the QR and Dustin\u2019s messages app opens with a note ready to send.",
      iframeTitle: "Book a 1-on-1 consultation with Dustin Campos",
      openCalendly: "Prefer a full window? Open Calendly in a new tab",
      qrLabel: "Scan to text Dustin",
      qrHint: "Point your camera here \u2014 your messages app opens with a note already written.",
      smsAria: "Scan the QR code or tap to send Dustin a text message",
      smsBody: "Aloha Dustin, I scanned the QR from your website and would like to connect.",
      callLabel: "Prefer to talk it through?",
      expectTitle: "What to expect",
      expect: [
        "A relaxed conversation about your family, goals and timeline",
        "Platinum carrier options presented side by side, in plain language",
        "No pressure, no obligation \u2014 ever",
      ],
    },
    faq: {
      eyebrow: "Straight answers",
      titleA: "Questions,",
      titleB: "answered honestly.",
      items: [
        {
          q: "What happens if the money is ignored?",
          a: "Unclaimed checks and dormant funds don\u2019t wait forever. If they go unclaimed, they are eventually sent to the state and become generalized funds. Once that happens, reclaiming your own money turns into a longer state process. Acting early keeps it simple.",
        },
        {
          q: "What does asset recovery cost me?",
          a: "Nothing upfront \u2014 ever. Dustin is paid a 20% share only if the recovery is successful and only after the funds reach you. If nothing is recovered, you owe nothing.",
        },
        {
          q: "What does the authorization letter allow?",
          a: "Before Dustin can act, you sign an acknowledgment letter authorizing him with limited power \u2014 strictly to contact the holding entity and confirm or release your funds. It grants no other authority over your money or your accounts.",
        },
        {
          q: "What happens at the 1-on-1 consultation?",
          a: "You and Dustin sit down \u2014 in person or by phone \u2014 to go over either your policy options or your estate and trust plan. Because the platinum life insurance and annuity companies aren\u2019t open to the public, quotes are shared only in this private setting.",
        },
      ],
    },
    footer: {
      tagline:
        "Plan. Protect. Provide. Licensed life, estate & trust planning and respectful asset recovery for the people and businesses of Maui, Hawai\u02BBi.",
      explore: "Explore",
      contact: "Contact",
      exploreLinks: {
        services: "Services",
        recovery: "Asset Recovery",
        about: "About Dustin",
        consult: "Book a Consultation",
        faq: "FAQ",
      },
      call: "Call:",
      text: "Text:",
      calendly: "Calendly: 1-hr in-person",
      location: "Wailuku, Maui, HI · Serving all of Maui",
      disclaimer:
        "Dustin Campos is an independent licensed life, estate & trust agent (License #21295806). Asset recovery services require no upfront fees; a 20% share is due only upon successful recovery, secured by a signed acknowledgment letter granting limited power solely to contact the holding entity. Platinum life insurance and annuity products are quoted by appointment only.",
      copyright: "Dustin Campos · Wailuku, Maui, HI",
    },
  },
  vi: {
    nav: {
      license: "Đại lý được cấp phép · #21295806",
      links: { services: "Dịch vụ", recovery: "Thu hồi", about: "Giới thiệu", consult: "Tư vấn", faq: "Hỏi đáp" },
      book: "Đặt lịch 1-1",
      call: "Gọi 808-500-4711",
      menuOpen: "Mở menu",
      menuClose: "Đóng menu",
    },
    hero: {
      badge: "Đại lý nhân thọ, di sản & tín thác được cấp phép · #21295806",
      location: "Wailuku · Maui, Hawai\u02BBi",
      lines: ["HOẠCH ĐỊNH.", "BẢO VỆ.", "CHU TOÀN."],
      paragraph:
        "Một lời chào thân ái từ Dustin Campos — đại lý độc lập và chủ doanh nghiệp nhỏ. Văn phòng của tôi mang đến các công ty bảo hiểm nhân thọ & annuity hạng bạch kim mà bạn không tìm thấy trên mạng, hoạch định di sản & tín thác chu đáo, và thu hồi số tiền đã thuộc về bạn một cách tôn trọng.",
      cta: "Đặt lịch tư vấn 1-1",
      textCta: "Nhắn tin 808-298-4096",
      chips: ["Không thu phí trước", "Chỉ 20% nếu thành công", "Phục vụ toàn bộ Maui, HI"],
      floatA: "Di sản của bạn,",
      floatB: "Trọng tâm của tôi.",
      floatBadge: "Đại lý độc lập",
      imgAlt: "Dustin Campos, đại lý nhân thọ, di sản và tín thác được cấp phép tại Wailuku, Maui",
    },
    marquee: [
      "Bảo hiểm nhân thọ hạng bạch kim",
      "Hoạch định di sản & tín thác",
      "Bảo hiểm chi phí cuối đời",
      "Thu hồi tài sản & séc",
      "Không thu phí trước",
      "Phục vụ Maui, Hawai\u02BBi",
    ],
    services: {
      eyebrow: "Văn phòng của tôi chuyên về",
      titleA: "Bảo hiểm hạng bạch kim.",
      titleB: "Hoạch định chu đáo.",
      titleC: " Tiền được thu hồi.",
      intro:
        "Ba chuyên môn, một tiêu chuẩn: lời khuyên trung thực, giải thích kiên nhẫn, và những lựa chọn mà hầu hết mọi người chưa từng được thấy. Mọi thứ bắt đầu từ một cuộc trò chuyện, không phải một bài bán hàng.",
      cards: [
        {
          title: "Bảo hiểm nhân thọ & Annuity hạng bạch kim",
          body: "Văn phòng của tôi chuyên về các công ty bảo hiểm nhân thọ và annuity hạng bạch kim không tiếp cận được công chúng. Bảo hiểm và báo giá chỉ được cung cấp qua phiên hoạch định 1-1 riêng tư.",
        },
        {
          title: "Hoạch định di sản & tín thác",
          body: "Cấu trúc chu đáo cho những gì bạn đã gây dựng — để mong muốn của bạn được tôn trọng và những người bạn yêu thương được bảo vệ tự tin.",
        },
        {
          title: "Bảo hiểm chi phí cuối đời",
          body: "Bảo hiểm trang nghiêm, thiết thực để chi phí chia ly không bao giờ đè lên vai gia đình bạn.",
        },
        {
          title: "Báo giá riêng, chỉ theo lịch hẹn",
          body: "Các công ty này không quảng cáo cho công chúng — đó chính là điểm đặc biệt. Gặp Dustin, so sánh con số thực, và ra về với một kế hoạch dành cho \u2018ohana của bạn.",
        },
      ],
      cta: "Đặt buổi tư vấn của bạn",
    },
    recovery: {
      eyebrow: "Thu hồi tài sản",
      titleA: "Tiền tìm được có",
      titleB: "hạn chót.",
      intro:
        "Séc chưa gửi và tiền chưa nhận đi qua bàn làm việc của công ty tôi. Tôi giúp cá nhân, doanh nghiệp và gia đình thu hồi những gì thuộc về họ — tôn trọng, kiên nhẫn, và giải thích rõ mọi thứ trước khi bạn ký bất cứ điều gì.",
      warningLead: "Đây là sự khẩn cấp trung thực:",
      warning:
        "nếu những khoản tiền này bị bỏ qua, cuối cùng chúng sẽ được gửi cho tiểu bang thành quỹ chung. Tôi không tin tiền của gia đình bạn nên nằm trong tài khoản chính phủ. Niềm tin đó là lý do tôi làm công việc này.",
      steps: [
        {
          title: "Chúng tôi tìm ra nó",
          body: "Séc chưa gửi, tiền mặt chưa nhận và tài khoản bị lãng quên xuất hiện qua công việc của công ty tôi. Nếu kết quả trùng khớp với bạn, tôi sẽ liên hệ với bạn.",
        },
        {
          title: "Bạn ký giấy ủy quyền có giới hạn",
          body: "Một thư xác nhận ủy quyền cho tôi quyền hạn giới hạn — chỉ để liên hệ với tổ chức đang giữ và xác nhận khoản tiền của bạn. Không hơn thế.",
        },
        {
          title: "Bạn thu hồi, rồi tôi mới được trả",
          body: "Tiền được chuyển thẳng đến bạn. Phí 20% của tôi chỉ được thanh toán sau khi thu hồi thành công — không bao giờ trước đó, không bao giờ trả trước.",
        },
      ],
      calc: {
        label: "Máy ước tính thu hồi",
        title: "Khoản tiền có thể trở về với bạn",
        description:
          "Kéo thanh trượt để chọn số tiền ước tính. Phép tính luôn như vậy: không thu phí trước, và chỉ 20% khi thu hồi thành công.",
        estLabel: "Số tiền ước tính",
        grossLabel: "Tiền thu hồi được",
        feeLabel: "Phí của Dustin (20%, chỉ khi thành công)",
        netLabel: "Bạn nhận được",
        cta: "Kiểm tra vụ việc của bạn",
      },
    },
    about: {
      eyebrow: "Gặp Dustin",
      titleA: "Di sản của bạn,",
      titleB: "trọng tâm của tôi.",
      p1: "Tôi là Dustin Campos, đại lý bảo hiểm nhân thọ, di sản & tín thác được cấp phép (Giấy phép #21295806) và là chủ doanh nghiệp nhỏ tại Wailuku. Công việc của tôi được xây dựng theo cách cũ — từng cuộc trò chuyện, từng gia đình, từng kế hoạch.",
      p2: "Văn phòng của tôi chuyên về các công ty bảo hiểm nhân thọ và annuity hạng bạch kim không mở cho công chúng. Những lựa chọn đó chỉ mở ra khi chúng ta ngồi lại cùng nhau cho phiên báo giá và hoạch định 1-1. Song song đó, tôi điều hành thực hành thu hồi tài sản: những tờ séc chưa gửi và tiền mặt chưa nhận đi qua công ty tôi, được trả về đúng cá nhân, doanh nghiệp và gia đình của họ.",
      p3: "Dù bạn đang bảo vệ những gì đã gây dựng hay thu hồi những gì đã thuộc về mình, bạn xứng đáng nhận được câu trả lời thẳng thắn bằng ngôn ngữ đơn giản — với sự kiên nhẫn và tôn trọng như một người hàng xóm.",
      quote: "Tôi không tin rằng tiền của bạn nên trở thành quỹ chung của tiểu bang.",
      quoteBy: "— Dustin Campos",
      islandAlt: "Bờ biển xanh mát của Maui, Hawai\u02BBi",
      facts: [
        { label: "Đại lý được cấp phép", value: "Giấy phép #21295806" },
        { label: "Văn phòng tại", value: "Wailuku, Maui" },
        { label: "Đại lý độc lập", value: "Chủ doanh nghiệp nhỏ" },
      ],
    },
    consult: {
      eyebrow: "Tư vấn 1-1",
      titleA: "Cùng Dustin ngồi lại.",
      titleB: "Bảo hiểm hoặc di sản & tín thác.",
      intro:
        "Chọn thời gian bên dưới để cùng xem lại các lựa chọn hợp đồng hoặc kế hoạch di sản & tín thác của bạn — trực tiếp hoặc qua điện thoại. Thích nhắn tin? Quét mã QR, ứng dụng nhắn tin sẽ mở sẵn với lời nhắn dành cho Dustin.",
      iframeTitle: "Đặt lịch tư vấn 1-1 với Dustin Campos",
      openCalendly: "Thích cửa sổ riêng? Mở Calendly trong tab mới",
      qrLabel: "Quét để nhắn tin cho Dustin",
      qrHint: "Hướng camera vào đây — ứng dụng nhắn tin của bạn sẽ mở với lời nhắn đã soạn sẵn.",
      smsAria: "Quét mã QR hoặc chạm để nhắn tin cho Dustin Campos",
      smsBody: "Aloha Dustin, tôi quét mã QR từ trang web của bạn và muốn kết nối.",
      callLabel: "Bạn muốn nói chuyện trực tiếp?",
      expectTitle: "Những gì sẽ diễn ra",
      expect: [
        "Một cuộc trò chuyện thoải mái về gia đình, mục tiêu và thời gian của bạn",
        "Các lựa chọn từ công ty hạng bạch kim được trình bày cạnh nhau, bằng ngôn ngữ đơn giản",
        "Không áp lực, không ràng buộc — luôn luôn",
      ],
    },
    faq: {
      eyebrow: "Câu trả lời thẳng thắn",
      titleA: "Câu hỏi,",
      titleB: "giải đáp trung thực.",
      items: [
        {
          q: "Điều gì xảy ra nếu khoản tiền bị bỏ qua?",
          a: "Séc chưa nhận và khoản tiền không hoạt động sẽ không chờ đợi mãi. Nếu bị bỏ qua, cuối cùng chúng sẽ được chuyển cho tiểu bang và trở thành quỹ chung. Khi đó, việc đòi lại tiền của bạn sẽ trở thành một quy trình nhà nước dài lâu. Hành động sớm sẽ giữ mọi thứ đơn giản.",
        },
        {
          q: "Thu hồi tài sản tốn bao nhiêu?",
          a: "Không mất gì trước — không bao giờ. Dustin chỉ nhận 20% nếu thu hồi thành công và chỉ sau khi tiền về đến bạn. Nếu không thu hồi được, bạn không nợ bất cứ điều gì.",
        },
        {
          q: "Thư ủy quyền cho phép những gì?",
          a: "Trước khi Dustin có thể hành động, bạn ký một thư xác nhận ủy quyền cho anh ấy quyền hạn giới hạn — nghiêm ngặt chỉ để liên hệ với tổ chức đang giữ và xác nhận hoặc giải phóng khoản tiền của bạn. Thư không cấp bất kỳ quyền hạn nào khác đối với tiền hoặc tài khoản của bạn.",
        },
        {
          q: "Buổi tư vấn 1-1 bao gồm những gì?",
          a: "Bạn và Dustin ngồi lại — trực tiếp hoặc qua điện thoại — để xem lại các lựa chọn hợp đồng hoặc kế hoạch di sản và tín thác. Vì các công ty bảo hiểm nhân thọ và annuity hạng bạch kim không mở cho công chúng, báo giá chỉ được chia sẻ trong buổi tư vấn riêng tư này.",
        },
      ],
    },
    footer: {
      tagline:
        "Hoạch định. Bảo vệ. Chu toàn. Hoạch định nhân thọ, di sản & tín thác được cấp phép và thu hồi tài sản tôn trọng, dành cho người dân và doanh nghiệp của Maui, Hawai\u02BBi.",
      explore: "Khám phá",
      contact: "Liên hệ",
      exploreLinks: {
        services: "Dịch vụ",
        recovery: "Thu hồi tài sản",
        about: "Giới thiệu Dustin",
        consult: "Đặt lịch tư vấn",
        faq: "Hỏi đáp",
      },
      call: "Gọi:",
      text: "Nhắn tin:",
      calendly: "Calendly: Tư vấn trực tiếp 1 giờ",
      location: "Wailuku, Maui, HI · Phục vụ toàn Maui",
      disclaimer:
        "Dustin Campos là đại lý độc lập được cấp phép về bảo hiểm nhân thọ, di sản & tín thác (Giấy phép #21295806). Dịch vụ thu hồi tài sản không thu phí trước; chỉ thu 20% khi thu hồi thành công, theo thư xác nhận ủy quyền giới hạn chỉ để liên hệ với tổ chức đang giữ. Các sản phẩm bảo hiểm nhân thọ & annuity hạng bạch kim chỉ được báo giá theo lịch hẹn.",
      copyright: "Dustin Campos · Wailuku, Maui, HI",
    },
  },
  ko: {
    nav: {
      license: "공인 에이전트 · #21295806",
      links: { services: "서비스", recovery: "자산 회복", about: "소개", consult: "상담", faq: "FAQ" },
      book: "1:1 상담 예약",
      call: "전화 808-500-4711",
      menuOpen: "메뉴 열기",
      menuClose: "메뉴 닫기",
    },
    hero: {
      badge: "공인 생명·자산·신탁 에이전트 · #21295806",
      location: "와이루쿠 · 마우이, 하와이",
      lines: ["계획.", "보호.", "준비."],
      paragraph:
        "Dustin Campos의 따뜻한 알로하를 전합니다 — 독립 에이전트이자 소상공인입니다. 제 사무실은 온라인에서 만날 수 없는 플래티넘 등급 생명보험 및 연금 회사, 신중한 자산·신탁 계획, 그리고 이미 고객님의 것인 돈을 존중하는 마음으로 회복하는 서비스를 제공합니다.",
      cta: "1:1 상담 예약하기",
      textCta: "문자 808-298-4096",
      chips: ["사전 비용 없음", "성공 시에만 20%", "마우이 전역 서비스"],
      floatA: "당신의 유산,",
      floatB: "나의 집중.",
      floatBadge: "독립 에이전트",
      imgAlt: "더스틴 캠포스, 와이루쿠 마우이의 공인 생명·자산·신탁 에이전트",
    },
    marquee: [
      "플래티넘 생명보험",
      "자산 및 신탁 계획",
      "장례 및 최종 비용 보장",
      "자산·수표 회복",
      "사전 비용 없음",
      "마우이, 하와이 서비스",
    ],
    services: {
      eyebrow: "제 사무실의 전문 분야",
      titleA: "플래티넘 보험.",
      titleB: "신중한 계획.",
      titleC: " 돈의 회복.",
      intro:
        "세 가지 전문 분야, 하나의 기준: 정직한 조언, 인내심 있는 설명, 그리고 아무도 보여주지 않던 선택지. 모든 것은 영업이 아닌 대화에서 시작됩니다.",
      cards: [
        {
          title: "플래티넘 생명보험 & 연금",
          body: "제 사무실은 일반 대중이 이용할 수 없는 플래티넘 등급 생명보험 및 연금 회사를 전문으로 합니다. 보험과 견적은 오직 1:1 개인 상담을 통해서만 제공됩니다.",
        },
        {
          title: "자산 및 신탁 계획",
          body: "쌓아온 것을 신중하게 정리하겠습니다 — 고객님의 뜻이 존중받고 사랑하는 사람들이 확신을 갖고 보호받도록.",
        },
        {
          title: "장례 및 최종 비용 보장",
          body: "작별의 비용이 가족의 어깨에 닿지 않도록 품위 있고 실용적인 보장.",
        },
        {
          title: "개인 견적, 예약제로만",
          body: "이 회사들은 대중에게 광고하지 않습니다 — 그것이 바로 핵심입니다. 더스틴과 마주 앉아 실제 숫자를 비교하고, 고객님의 \u2018오하나(가족)\u2019에 맞춘 계획을 갖고 돌아가세요.",
        },
      ],
      cta: "상담 시간 예약하기",
    },
    recovery: {
      eyebrow: "자산 회복",
      titleA: "찾은 돈에는",
      titleB: "기한이 있습니다.",
      intro:
        "미입금 수표와 미수령 현금은 제 회사의 책상을 거쳐갑니다. 저는 개인, 사업체, 가족이 자신의 돈을 찾도록 돕습니다 — 존중과 인내로, 무엇을 서명하기 전에 모든 것을 설명드립니다.",
      warningLead: "정직하게 말씀드리면:",
      warning:
        "이 자금을 방치하면 결국 주(州)의 일반 기금으로 넘어갑니다. 고객님 가족의 돈이 정부 계좌에 갇히는 것은 옳지 않다고 믿습니다. 그 믿음이 제가 이 일을 하는 이유입니다.",
      steps: [
        {
          title: "저희가 먼저 찾아냅니다",
          body: "미입금 수표, 미수령 현금, 잠자던 계좌가 회사 업무를 통해 발견됩니다. 고객님과 일치하는 건이 있으면 제가 먼저 연락드립니다.",
        },
        {
          title: "제한된 위임 승인서에 서명합니다",
          body: "승인서는 제한된 권한만 부여합니다 — 보관 기관에 연락해 고객님의 자금을 확인하는 일만 가능합니다. 그 이상은 아닙니다.",
        },
        {
          title: "고객님이 수령하면, 그때 제가 급여를 받습니다",
          body: "자금은 고객님께 직접 갑니다. 제 20% 수수료는 회복이 성공한 이후에만 청구됩니다 — 절대 미리, 절대 선불로 받지 않습니다.",
        },
      ],
      calc: {
        label: "회복 추정기",
        title: "얼마가 돌아올 수 있을까요",
        description:
          "슬라이더로 예상 자금 규모를 움직여 보세요. 계산은 언제나 같습니다: 선불 없음, 성공 시에만 20%.",
        estLabel: "예상 자금",
        grossLabel: "회복 자금",
        feeLabel: "더스틴 수수료 (20%, 성공 시만)",
        netLabel: "고객님이 받는 금액",
        cta: "사례 확인하기",
      },
    },
    about: {
      eyebrow: "더스틴 소개",
      titleA: "당신의 유산,",
      titleB: "나의 집중.",
      p1: "저는 더스틴 캠포스, 와이루쿠에서 활동하는 공인 생명·자산·신탁 에이전트(면허 #21295806)이자 소상공인입니다. 제 업무는 오래된 방식으로 만들어졌습니다 — 한 번의 대화, 한 가족, 한 계획씩.",
      p2: "제 사무실은 일반 대중에게 개방되지 않은 플래티넘 생명보험 및 연금 회사를 전문으로 합니다. 그 선택지는 1:1 견적 및 계획 상담에서 함께 앉을 때 열립니다. 아울러 자산 회복 업무를 운영합니다: 제 회사를 거치는 미입금 수표와 미수령 현금을 개인, 사업체, 가족과 다시 연결합니다.",
      p3: "쌓아온 것을 지키든, 이미 고객님의 것을 되찾든, 고객님은 이웃에게 기대하는 인내와 존중으로 단순한 언어의 정직한 답을 받을 자격이 있습니다.",
      quote: "고객님의 돈이 주의 일반 기금이 되어야 한다고는 믿지 않습니다.",
      quoteBy: "— 더스틴 캠퍼스",
      islandAlt: "마우이, 하와이의 푸른 해안선",
      facts: [
        { label: "공인 에이전트", value: "면허 #21295806" },
        { label: "사무실 위치", value: "와이루쿠, 마우이" },
        { label: "독립 에이전트", value: "소상공인" },
      ],
    },
    consult: {
      eyebrow: "1:1 상담",
      titleA: "더스틴과 마주 앉으세요.",
      titleB: "보험 검토 또는 자산·신탁 계획.",
      intro:
        "아래에서 시간을 선택해 보험 옵션이나 자산·신탁 계획을 함께 검토하세요 — 대면 또는 전화로. 문자가 편하신가요? QR을 스캔하면 더스틴에게 보내는 메시지가 작성된 채 문자 앱이 열립니다.",
      iframeTitle: "더스틴 캠포스와 1:1 상담 예약",
      openCalendly: "전체 창이 편하신가요? 새 탭에서 Calendly 열기",
      qrLabel: "QR로 문자 보내기",
      qrHint: "카메라를 여기에 향하세요 — 메시지 앱이 미리 작성된 메시지와 함께 열립니다.",
      smsAria: "QR 코드를 스캔하거나 탭하여 더스틴 캠포스에게 문자를 보내세요",
      smsBody: "Aloha Dustin, 웹사이트의 QR을 스캔했습니다. 연락하고 싶습니다.",
      callLabel: "전화로 상담하고 싶으신가요?",
      expectTitle: "상담에서 기대할 것",
      expect: [
        "가족, 목표, 일정에 관한 편안한 대화",
        "플래티넘 등급 회사의 옵션을 단순한 언어로 나란히 비교",
        "압박 없음, 의무 없음 — 언제나 그렇습니다",
      ],
    },
    faq: {
      eyebrow: "솔직한 답변",
      titleA: "질문,",
      titleB: "정직하게 답했습니다.",
      items: [
        {
          q: "자금을 방치하면 어떻게 되나요?",
          a: "미수령 수표와 휴면 자금은 영원히 기다리지 않습니다. 방치하면 결국 주(州)로 넘어가 일반 기금이 됩니다. 그 시점부터 본인의 돈을 되찾는 일은 더 긴 주 정부 절차가 됩니다. 조기에 행동하면 모든 것이 단순해집니다.",
        },
        {
          q: "자산 회복 비용은 얼마인가요?",
          a: "선불은 절대 없습니다. 더스틴은 회복이 성공하고 자금이 고객님에게 도착한 이후에만 20%를 받습니다. 회복되지 못하면 받는 것도 없습니다.",
        },
        {
          q: "승인서는 무엇을 허용하나요?",
          a: "더스틴이 움직이기 전에 고객님은 제한된 권한만 부여하는 승인서에 서명합니다 — 오직 보관 기관에 연락해 고객님의 자금을 확인하거나 해제하는 것만 가능합니다. 고객님의 돈이나 계좌에 대한 다른 어떤 권한도 없습니다.",
        },
        {
          q: "1:1 상담에서는 무엇을 하나요?",
          a: "고객님과 더스틴이 마주 앉아 — 대면 또는 전화로 — 보험 옵션이나 자산·신탁 계획을 검토합니다. 플래티넘 생명보험 및 연금 회사는 대중에게 공개되지 않기 때문에 견적은 이 개인 상담에서만 공유됩니다.",
        },
      ],
    },
    footer: {
      tagline:
        "계획. 보호. 준비. 마우이, 하와이의 개인과 사업체를 위한 공인 생명·자산·신탁 계획과 존중하는 자산 회복 서비스.",
      explore: "탐색",
      contact: "연락처",
      exploreLinks: {
        services: "서비스",
        recovery: "자산 회복",
        about: "더스틴 소개",
        consult: "상담 예약",
        faq: "FAQ",
      },
      call: "전화:",
      text: "문자:",
      calendly: "Calendly: 1시간 대면 상담",
      location: "와이루쿠, 마우이, HI · 마우이 전역 서비스",
      disclaimer:
        "Dustin Campos는 공인 생명·자산·신탁 에이전트입니다(면허 번호 #21295806). 자산 회복 서비스는 선불이 없으며, 성공적인 회복 이후에만 20%를 받습니다. 이는 보관 기관에 연락할 권한만 부여하는 제한된 위임 승인서로 보장됩니다. 플래티넘 생명보험 및 연금 상품은 예약자에 한해 견적을 제공합니다.",
      copyright: "더스틴 캠포스 · 와이루쿠, 마우이, HI",
    },
  },
};
